// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import EllipsisOutlinedSvg from "@ant-design/icons-svg/lib/asn/EllipsisOutlined";
import AntdIcon from "../components/AntdIcon";
const EllipsisOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: EllipsisOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    EllipsisOutlined.displayName = "EllipsisOutlined";
}
export default /*#__PURE__*/ React.forwardRef(EllipsisOutlined);
